import script from "./defense-config.vue?vue&type=script&setup=true&lang=ts"
export * from "./defense-config.vue?vue&type=script&setup=true&lang=ts"

import "./defense-config.vue?vue&type=style&index=0&id=b3ac6726&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3ac6726"]])

export default __exports__